"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Layout_1 = __importDefault(require("../../context/Layout"));
var useCatalogLink = function (_a) {
    var _b = _a.referrerUrl, referrerUrl = _b === void 0 ? '' : _b, lang = _a.lang;
    var _c = __read((0, react_1.useContext)(Layout_1.default), 2), currentIdentityQuery = _c[0], layoutQuery = _c[1];
    var catalogLink = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var currentIdentity = (_a = currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data) === null || _a === void 0 ? void 0 : _a.currentIdentity;
        var defaultBank = ((_c = (_b = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data) === null || _b === void 0 ? void 0 : _b.bankBalance) === null || _c === void 0 ? void 0 : _c.find(function (bank) { return bank.defaultBank; })) ||
            ((_e = (_d = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data) === null || _d === void 0 ? void 0 : _d.bankBalance) === null || _e === void 0 ? void 0 : _e[0]);
        if (!currentIdentity || !defaultBank)
            return '';
        var queryParams = new URLSearchParams({
            countryCode: ((_g = (_f = currentIdentity.profile) === null || _f === void 0 ? void 0 : _f.catalogCoreCountry) === null || _g === void 0 ? void 0 : _g.iso2Code) ||
                ((_j = (_h = currentIdentity.profile) === null || _h === void 0 ? void 0 : _h.homeCoreLocation) === null || _j === void 0 ? void 0 : _j.country) ||
                '',
            programId: ((_k = defaultBank === null || defaultBank === void 0 ? void 0 : defaultBank.programId) === null || _k === void 0 ? void 0 : _k.toString()) || '',
            refererUrl: referrerUrl,
            locale: (lang || ((_l = navigator.languages) === null || _l === void 0 ? void 0 : _l[0]) || navigator.language).replace('-', '_'),
        });
        return "/catalog?".concat(queryParams);
    }, [referrerUrl, lang, currentIdentityQuery === null || currentIdentityQuery === void 0 ? void 0 : currentIdentityQuery.data, layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data]);
    return catalogLink;
};
exports.default = useCatalogLink;
//# sourceMappingURL=index.js.map